import { LabelT6, LabelT7 } from "Components/Common/Label/index";
import { Spacer } from "Components/Common/Spacer/index";
import React, { Fragment } from "react";
import { ReactComponent as PlusIcon } from "Icons/plus-theme.svg";
import { ReactComponent as DownloadIcon } from "Icons/downloadIconT1.svg";
import { ReactComponent as CloseIconT1 } from "Icons/closeIconT1.svg";
import Upload from "Components/Upload";
import styled from "@emotion/styled";
import {
  TypographyT53,
  TypographyT54,
  TypographyT58,
} from "Components/Common/Typography/index";
import { Wrapper } from "Components/Common/Wrapper/index";
import Input from "Components/Input/index";
import SelectT1 from "Components/Common/Select/SelectT1";
import { ButtonT10, IconButtonT1 } from "Components/Common/Button/index";
import {
  FlexWrapperT12,
  FlexWrapperT3,
  FlexWrapperT7,
} from "Components/Common/Wrapper/FlexWrapper";
import { isDesmetSupplier } from "Utils/index";

const styles = {
  control: (styles, state) => {
    return {
      ...styles,
      minWidth: "209px",
      maxWidth: "250px",
    };
  },
  option: (styles, state) => {
    return {
      ...styles,
      // maxWidth: "180px",
    };
  },
};

const CargoDescription = (props) => {
  const {
    handleDownloadCargoMaterialPackingTemaplateFile,
    handleOnChangeForCargoMaterialPackingTemplateFile,
    material_packing_list = [],
    handleOnClickForAddMaterialPackingBtn,
    handleOnClickForRemoveMaterialPackingBtn,
    handleOnChangeForMaterialPackingInputs,
    packingTypesList,
      } = props;

  const handleGetPackagingType = (ele) => {
    console.log("ele:", ele);

    const packagingType = {
      label: ele.type_of_packing,
      value: ele.packing_type_id,
    };

    const C1 = !!!packagingType.label;
    const C2 = !!!packagingType.value;

    if (C1 && C2) {
      return null;
    }

    return packagingType;
  };

  const shouldRenderTotalSection = () => {
    const C1 = material_packing_list.length > 0;

    if (C1) {
      return true;
    }

    return false;
  };
  const getTotal = () => {
    const total = {
      totalQty: 0,
      totalTareWeight: 0,
      totalGrossWeight: 0,
      totalNetWeight: 0,
      totalVol: 0,
    };

    total.totalQty = material_packing_list.reduce((tv, cv) => {
      return +tv + +cv.packing_qty;
    }, 0);

    // total.totalTareWeight = material_packing_list.reduce((tv,cv)=>{
    //   return +tv + +cv.tare_weight
    // },0)

    total.totalNetWeight = material_packing_list.reduce((tv, cv) => {
      return +tv + +cv.net_weight;
    }, 0);

    total.totalGrossWeight = material_packing_list.reduce((tv, cv) => {
      return +tv + +cv.gross_weight;
    }, 0);

    total.totalVol = material_packing_list.reduce((tv, cv) => {
      return +tv + +cv.volume;
    }, 0);

    return total;
  };

  const total = getTotal();

  return (
    <Fragment>
      <div className="flex flex-between flex-middle gap-20">
        <LabelT6>Cargo Description</LabelT6>
        {isDesmetSupplier() && (
          <Fragment>
            <div className="flex flex-right flex-middle gap-20">
              <div>
                <button
                  onClick={handleDownloadCargoMaterialPackingTemaplateFile}
                  className="flex flex-middle flex-center border-theme wt-200 ht-40 bg-white theme-color fBold fs-16 br-20"
                >
                  <DownloadIcon className="mr-10" />
                  Template
                </button>
              </div>
              <div>
                <Upload
                  onChange={handleOnChangeForCargoMaterialPackingTemplateFile}
                  value="Upload File"
                  fileSize={40}
                >
                  <button className="flex flex-middle flex-center border-theme wt-200 ht-40 bg-white theme-color fBold fs-16 br-20">
                    <PlusIcon className="mr-10" />
                    Upload Packing List
                  </button>
                </Upload>
              </div>
            </div>
          </Fragment>
        )}
      </div>
      <Spacer spacing={"4px"} />
      {material_packing_list.map((ele, ind) => {
        return (
          <Fragment key={ind}>
            <RowWrapper>
              <LeftSideWrapper>
                <Spacer spacing={"3px"} />
                <TypographyT58>{ind + 1}</TypographyT58>
              </LeftSideWrapper>
              <MiddleWrapper>
                {/* <Wrapper>
                  <LabelT7>Package Number</LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    placeholder={"Enter here"}
                    name={"package_number"}
                    value={ele.package_number}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled = {!isDesmetSupplier()}
                  />
                </Wrapper> */}
                <Wrapper>
                  <LabelT7>Desmet Package No.<span style={{ color: "red" }}> *</span></LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    placeholder={"Enter here"}
                    name={"desmet_package_no"}
                    value={ele.desmet_package_no}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Type of Packing<span style={{ color: "red" }}> *</span></LabelT7>
                  <Spacer spacing={"1px"} />
                  <SelectT1
                    placeholder={"Select"}
                    isClearable={true}
                    options={packingTypesList}
                    isSearchable={true}
                    styles={styles}
                    value={handleGetPackagingType(ele)}
                    onChange={(data) => {
                      handleOnChangeForMaterialPackingInputs(
                        data,
                        ind,
                        "type_of_packing"
                      );
                    }}
                    isDisabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Item Number<span style={{ color: "red" }}> *</span></LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    placeholder={"Enter here"}
                    name={"item_number"}
                    value={ele.item_number}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Qty<span style={{ color: "red" }}> *</span></LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    className={"wt-100"}
                    placeholder={"Enter here"}
                    name={"packing_qty"}
                    value={ele.packing_qty}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Unit<span style={{ color: "red" }}> *</span></LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    className={"wt-100"}
                    placeholder={"Enter here"}
                    name={"packing_unit"}
                    value={ele.packing_unit}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Material Des.<span style={{ color: "red" }}> *</span></LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    placeholder={"Enter here"}
                    name={"material_des"}
                    value={ele.material_des}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>

                <Wrapper>
                  <LabelT7>Gross Weight(Kg)<span style={{ color: "red" }}> *</span> :</LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    className={"wt-100"}
                    placeholder={"Enter here"}
                    name={"gross_weight"}
                    value={ele.gross_weight}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Net Weight(Kg)<span style={{ color: "red" }}> *</span>:</LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    className={"wt-100"}
                    placeholder={"Enter here"}
                    name={"net_weight"}
                    value={ele.net_weight}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Length (cm)<span style={{ color: "red" }}> *</span>:</LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    className={"wt-100"}
                    placeholder={"Enter here"}
                    name={"length"}
                    value={ele.length}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Width (cm)<span style={{ color: "red" }}> *</span> :</LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    className={"wt-100"}
                    placeholder={"Enter here"}
                    name={"width"}
                    value={ele.width}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Height (cm)<span style={{ color: "red" }}> *</span> :</LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    className={"wt-100"}
                    placeholder={"Enter here"}
                    name={"height"}
                    value={ele.height}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Vol (m3)<span style={{ color: "red" }}> *</span> :</LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    className={"wt-100"}
                    placeholder={"Enter here"}
                    name={"volume"}
                    value={ele.volume}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    // disabled = {!isDesmetSupplier()}
                    disabled={true}
                  />
                </Wrapper>
                <Wrapper>
                  <LabelT7>Remarks:</LabelT7>
                  <Spacer spacing={"1px"} />
                  <Input
                    placeholder={"Enter here"}
                    name={"remarks"}
                    value={ele.remarks}
                    onChange={(event) => {
                      handleOnChangeForMaterialPackingInputs(event, ind);
                    }}
                    disabled={!isDesmetSupplier()}
                  />
                </Wrapper>
              </MiddleWrapper>
              {isDesmetSupplier() && (
                <RightSideWrapper>
                  <IconButtonT1
                    onClick={() => {
                      handleOnClickForRemoveMaterialPackingBtn(ind);
                    }}
                  >
                    <CloseIconT1 />
                  </IconButtonT1>
                </RightSideWrapper>
              )}
            </RowWrapper>
            <Spacer spacing={"4px"} />
          </Fragment>
        );
      })}
      {shouldRenderTotalSection() && (
        <Fragment>
          <Spacer spacing={"3px"} />
          <FlexWrapperT12>
            <FlexWrapperT7>
              <TypographyT53>Total Qty :</TypographyT53>
              <TypographyT54 style={{ textAlign: "center" }}>
                {total.totalQty}
              </TypographyT54>
            </FlexWrapperT7>
            <FlexWrapperT7>
              <TypographyT53>Total Net Weight(Kg) :</TypographyT53>
              <TypographyT54 style={{ textAlign: "center" }}>
                {total.totalNetWeight}
              </TypographyT54>
            </FlexWrapperT7>
            <FlexWrapperT7>
              <TypographyT53>Total Gross Weight(Kg) :</TypographyT53>
              <TypographyT54 style={{ textAlign: "center" }}>
                {total.totalGrossWeight}
              </TypographyT54>
            </FlexWrapperT7>
            <FlexWrapperT7>
              <TypographyT53>Total Vol (m3) :</TypographyT53>
              <TypographyT54 style={{ textAlign: "center" }}>
                {total.totalVol}
              </TypographyT54>
            </FlexWrapperT7>
          </FlexWrapperT12>
        </Fragment>
      )}
      <Spacer spacing={"3px"} />
      {isDesmetSupplier() && (
        <ButtonT10
          onClick={handleOnClickForAddMaterialPackingBtn}
          style={{
            padding: "8px 20px",
          }}
        >
          + Add
        </ButtonT10>
      )}
    </Fragment>
  );
};

export default CargoDescription;

const RowWrapper = styled.div`
  border-radius: 5px;
  background: rgba(188, 197, 230, 0.3);
  padding: 10px;
  display: flex;
  gap: 10px;
`;

const LeftSideWrapper = styled.div``;

const MiddleWrapper = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;

const RightSideWrapper = styled.div`
  border-left: 2px solid #677586;
  padding-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
